import * as i0 from "@angular/core";
var FormGroupService = /** @class */ (function () {
    function FormGroupService() {
    }
    FormGroupService.prototype.markFormAsTouched = function (form, opts) {
        Object.keys(form.controls).forEach(function (kControl) {
            var control = form.controls[kControl];
            control.markAsTouched(opts);
        });
    };
    FormGroupService.prototype.markFormAsUntouched = function (form, opts) {
        Object.keys(form.controls).forEach(function (kControl) {
            var control = form.controls[kControl];
            control.markAsUntouched(opts);
        });
    };
    FormGroupService.prototype.markFormAsPristine = function (form, opts) {
        Object.keys(form.controls).forEach(function (kControl) {
            var control = form.controls[kControl];
            control.markAsPristine(opts);
        });
    };
    FormGroupService.ngInjectableDef = i0.defineInjectable({ factory: function FormGroupService_Factory() { return new FormGroupService(); }, token: FormGroupService, providedIn: "root" });
    return FormGroupService;
}());
export { FormGroupService };
